export default [
  {
    path: '/mantenedor/tarifas-manage2',
    name: 'mantenedor-tarifas-manage2',
    component: () => import('@/pages/mantenedor/tarifas-manage2/TarifasManage2Page.vue'),
    meta: { requiresAuth: true },
  },
];
